import * as React from "react";

function SvgIcons8Support(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M21 3c-4.43 0-8 3.57-8 8 0 .234.035.555.063.844L4.5 20.406a4.998 4.998 0 000 7.094 4.998 4.998 0 007.094 0l8.562-8.563c.29.028.61.063.844.063 4.43 0 8-3.57 8-8a7.597 7.597 0 00-.938-3.688l-.625-1.156-.937.938-4.313 4.281-1.562-1.563L24.906 5.5l.938-.938-1.157-.625A7.597 7.597 0 0021 3zm0 2c.484 0 .848.207 1.281.313l-4.5 4.5.719.687 3 3 .688.719 4.5-4.5c.105.433.312.797.312 1.281 0 3.371-2.629 6-6 6-.398 0-.723 0-.969-.063l-.531-.156-9.313 9.313c-1.23 1.23-3.05 1.23-4.28 0l-.032-.032c-1.2-1.23-1.191-3.027.031-4.25L15.22 12.5l-.156-.531C15 11.723 15 11.399 15 11c0-3.371 2.629-6 6-6z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Support);
